import {
    GET_PRODUCT_AND_SERVICE_DATA,
    ERROR_GET_PRODUCT_AND_SERVICE_DATA
  } from '../types';
  
  const initialState = {
    productsAndServices: [],
    productsAndServicesLoading: true,
    productsAndServicesError: ''
  };
  
  export default function productsAndServicesReducer(state = initialState, action) {
    switch (action.type) {
      case GET_PRODUCT_AND_SERVICE_DATA:
        return {
          ...state,
          productsAndServices: action.payload,
          productsAndServicesLoading: false
        };
        
      case ERROR_GET_PRODUCT_AND_SERVICE_DATA:
        return {
          ...state,
          productsAndServicesError: action.payload.message,
          productsAndServicesLoading: false
        };
        
      default:
        return state;
    }
  }
    
  